import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';

@Component({
    selector: 'new-dymanic-form',
    templateUrl: './new_forms.component.html',
    styleUrls: ['./new_forms.component.scss'],
    standalone: false
})

export class NewFormsComponent implements OnInit {

  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor() {}

  ngOnInit() {

  }

  addElement(type) {

  }
}
